<template>
    <g
        :transform="'translate('+x+','+y+')'"
        :class="nodeClass"
        @click="handleClick"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
    >
        <g>
            <g v-if="node.virtual">
                <node-line
                    :path="virtualPath"
                    :weight="status"
                />
            </g>
            <g v-else class="svgResultStatus">
                <circle
                    cx="0"
                    cy="0"
                    r="15"
                    :class="circleClass"
                />
                <g
                    v-if="status=='failure' || status == 'error'"
                    class="result-status-glyph"
                >
                    <use
                        href="#failureIcon"
                        fill="white"
                    />
                </g>
                <g
                    v-if="status=='success'"
                    class="result-status-glyph"
                >
                    <use
                        href="#successIcon"
                        fill="white"
                    />
                </g>
                <g
                    v-if="status=='current'"
                    class="result-status-glyph"
                >
                    <use
                        href="#userIcon"
                        x="-7"
                        y="-8"
                        fill="white"
                    />
                </g>
                <g
                    v-if="status=='pending'"
                    class="result-status-glyph"
                >
                    <use
                        href="#userIcon"
                        x="-7"
                        y="-8"
                        fill="white"
                    />
                </g>
                <g
                    v-if="status=='no-audit'"
                    class="result-status-glyph"
                >
                    <use
                        href="#userIcon"
                        x="-7"
                        y="-8"
                        fill="white"
                    />
                </g>
                <g
                    v-if="status=='paused'"
                    class="result-status-glyph"
                >
                    <use
                        href="#pausedIcon"
                        fill="black"
                    />
                </g>
            </g>
            <template v-if="!node.virtual">
                <g>
                    <text
                        :x="getText(label).x"
                        :y="getText(label).y"
                        class="flow-graph-node-label"
                        :class="handleTextClass(highlight,status)"
                    >
                        {{ getText(label).text }}
                    </text>
                </g>

                <g
                    v-for="(info, idx) in node.extraInfos"
                    :key="idx"
                    :ref="`node${index}-extraInfoRef-${idx}`"
                >
                    <text
                        :x="getText(info.name).x"
                        :y="getText(info.name).y + (idx + 1) * 15"
                        class="flow-graph-extra-info-text"
                        :class="status=='no-audit' ? 'flow-graph-extra-info-text-no-audit' : ''"
                        @mouseenter="info.title && handleTextMouseEnter(info.title, idx)"
                        @mouseleave="info.title && handleTextMouseLeave()"
                    >
                        {{ info.name }}
                    </text>
                </g>
            </template>
        </g>
    </g>
</template>
<script>
import stringWidth from 'string-width';
import NodeLine from './Line.vue';

export default {
    components: {
        NodeLine,
    },
    props: {
        index: {
            type: Number,
        },
        /**
         * 成功success 失败failure 待办pending 进行中current 异常error
         */
        status: {
            type: String,
            default: 'pending',
        },
        label: {
            type: String,
        },
        x: {
            type: Number,
        },
        y: {
            type: Number,
        },
        // 虚拟节点
        virtual: {
            type: Boolean,
            default: false,
        },
        // 是否高亮
        highlight: {
            type: Boolean,
            default: false,
        },
        node: {
            type: Object,
        },
        selected: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            nodeClass: 'flow-graph-node',
        };
    },
    computed: {
        circleClass() {
            const classList = ['circle-bg', `${this.status}`];
            if (this.node.virtual) {
                classList.push('virtual');
            }
            return classList;
        },
        virtualPath() {
            return 'M-13 0 H 10';
        },
        handleTextClass() {
            return (highlight, status) => {
                let textClass = '';
                if(highlight) textClass += 'highlight';
                if(status === 'no-audit') textClass += ' flow-graph-node-label-no-audit';
                return textClass;
            };
        },
    },
    methods: {
        getText(text) {
            const width = stringWidth(text);
            return {
                x: -width * 2.7,
                y: 30,
                text,
            };
        },
        handleClick() {
            this.$emit('click', this.node);
        },
        getExtraInfoRef(idx) {
            const refs = this.$refs[`node${this.index}-extraInfoRef-${idx}`];
            return refs && refs[0];
        },
        handleMouseEnter() {
            this.nodeClass = 'flow-graph-node-selected';
            this.$emit('mouseenter', this.index, this.node);
        },
        handleMouseLeave() {
            this.nodeClass = 'flow-graph-node';
            this.$emit('mouseleave', this.index, this.node);
        },
        handleTextMouseEnter(content, idx) {
            const ref = this.getExtraInfoRef(idx);
            if (!ref) return;
            const { top, left } = ref.getBoundingClientRect();
            this.$emit('text-mouseenter', {
                content,
                left,
                top,
            });
        },
        handleTextMouseLeave() {
            this.$emit('text-mouseleave');
        },
    },
};
</script>
<style lang="css">
.flow-graph-node-selected .svgResultStatus > circle {
  stroke: none;
}

.svgResultStatus {
  transform: translateZ(0);
}
.svgResultStatus > circle {
  stroke: white;
  stroke-width: 2px;

}
.svgResultStatus > circle.success,
.svgResultStatus > circle.current {
  fill: rgb(104, 208, 130);
}
.svgResultStatus > circle.failure,
.svgResultStatus > circle.error {
  fill: rgb(246, 42, 25);
}
.svgResultStatus > circle.pending {
  fill: rgb(134, 134, 134);
}
.svgResultStatus > circle.no-audit {
  fill: rgb(233, 233, 233);
}

/* .svgResultStatus > circle.virtual {
    opacity: 0.2;
} */

.flow-graph-node-label {
  font: 12px sans-serif;
  font-size: 12px;
  /* fill: red; */
  width: 100px;
  overflow: hidden;
  overflow-wrap: break-word;
  /* top: 140px; */
  /* left: 339px; */
  position: absolute;
  width: 89px;
  /* max-height: 39px; */
  text-align: center;
}

.flow-graph-node-label.highlight {
    font-weight: bold;
}
.flow-graph-node-label-no-audit {
    fill:rgb(207, 207, 207);
}

.flow-graph-extra-info-text {
    fill: rgb(134, 134, 134);
    font-size: 12px;
}
.flow-graph-extra-info-text-no-audit{
    fill:rgb(207, 207, 207);
}

</style>
